import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { State, WorkflowInvoke } from '@sierralabs/workflow';
import { useState } from 'react';
import styled from 'styled-components';
import InlineFormik from '../../../../common/inline/InlineFormik';
import InlineHtml from '../../../../common/inline/InlineHtml';
import { Group } from '../../../groups/Group.interface';
import { SendEmailParams } from '../../../tasks/Task.machine';
import MultiUserSelector from '../../../users/components/MultiUserSelector';
import GroupSelector from '../../components/GroupSelector';
import {
  ServiceConfiguratorProps,
  ServiceDisplayProps,
  ServicePlugin
} from '../ServicePlugin';

const StyledConfiguratorDiv = styled.div`
  .field {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .MuiTableCell-root {
    padding: 12px 5px 12px 5px;
  }
`;

const SendEmailConfigurator: React.FC<ServiceConfiguratorProps> = props => {
  const { onChange } = props;
  const [invoke, setInvoke] = useState(props.invoke);
  if (!invoke.data) invoke.data = {};
  const data: SendEmailParams['data'] = invoke.data;

  const handleUpdateInvoke = (data: SendEmailParams['data']) => {
    const updatedInvoke = { ...invoke, data };
    setInvoke(updatedInvoke);
    onChange?.(updatedInvoke);
  };
  return (
    <StyledConfiguratorDiv>
      <GroupSelector
        multiple
        value={data.groupIds}
        textFieldProps={{
          size: 'medium',
          label: 'Select Team(s)'
        }}
        onChange={(groups: Group[]) => {
          data.groupIds = groups.map(group => group.id);
          handleUpdateInvoke(data);
        }}
      />
      <MultiUserSelector
        value={data.userIds}
        textFieldProps={{ label: 'Select User(s)', placeholder: undefined }}
        onChange={users => {
          data.userIds = users.map(user => user.id);
          handleUpdateInvoke(data);
        }}
      />
      <TextField
        variant='outlined'
        label='Specific Email IDs'
        className='field'
        fullWidth
        value={data.specificEmailIds}
        onChange={event => {
          data.specificEmailIds = event.target.value;
          handleUpdateInvoke(data);
        }}
      />
      <FormControlLabel
        label='Include link to item '
        control={
          <Checkbox
            color='primary'
            checked={data.includeLinkToItem}
            onChange={(_, checked: boolean) => {
              data.includeLinkToItem = checked;
              handleUpdateInvoke(data);
            }}
          />
        }
      />
      <InlineFormik
        initialValues={{ message: data.message || '' }}
        onSubmit={({ message }) => {
          data.message = message;
          handleUpdateInvoke(data);
        }}
      >
        <InlineHtml name='message' helperText='Enter Custom Message' />
      </InlineFormik>
    </StyledConfiguratorDiv>
  );
};

const SendEmailDisplay: React.FC<ServiceDisplayProps> = ({ invoke }) => {
  return null;
};

export const SendEmailPlugin: ServicePlugin<SendEmailParams> = {
  src: 'sendEmail',
  name: 'Send Email',
  configurator: SendEmailConfigurator,
  display: SendEmailDisplay,
  validate: (condition: Partial<WorkflowInvoke>) => {
    return true;
  },
  service: (state: State<any>, params: SendEmailParams) => {
    console.log('sendEmail state', state);
    return true;
  }
};
